import { FC, Ref, useRef } from 'react';
import { useAutoAnimate } from '@formkit/auto-animate/react';
import { TitleRow } from 'components/TitleRow';
import { Link } from 'react-router-dom';
import styles from './EmployedsList.module.scss';
import { Nothing } from 'components/Nothing';
import { EmployedType } from 'redux/Api/employedsWorkSupportApi/type';
import { EmployedWorkSupportItem } from 'ui/EmployedWorkSupportItem';
import type { UseInfiniteScrollHookRefCallback } from 'react-infinite-scroll-hook';

interface EmployedsListTypes {
  data: EmployedType[];
  intersectionRef?: UseInfiniteScrollHookRefCallback;
  rootRef?: Ref<HTMLDivElement>;
}

export const EmployedsWorkSupportList: FC<EmployedsListTypes> = ({
  data,
  intersectionRef,
  rootRef,
}) => {
  const [parent] = useAutoAnimate({ duration: 300 });
  const refList = useRef<HTMLDivElement>(null);

  const role = localStorage.getItem('role') || 'WorkSupport';

  const dataTitle = [
    'id',
    'ФИО',
    'ИНН',
    'Налоговый статус',
    'Гражданство',
    'Дата обновления',
    'Статус',
  ];

  const Row = ({ index }: { index: number }) => {
    return (
      <div>
        {data && (
          <Link to={`/employedsWorkSupport/${data[index]?.id}`}>
            <EmployedWorkSupportItem role={role} employed={data[index]} />
          </Link>
        )}
      </div>
    );
  };
  return (
    <div ref={parent} className={styles.root}>
      <TitleRow data={dataTitle} title={'employeds'} />
      {data?.length ? (
        <div className={styles.window} ref={rootRef ?? refList}>
          {data.map((_, index) => {
            const triggerIndex = Math.max(0, data.length - 8);
            const shouldAttachRef = index === triggerIndex;
            return (
              <div
                key={`${data[index]?.id}-${index}`}
                ref={shouldAttachRef ? intersectionRef : undefined}>
                <Row index={index} />
              </div>
            );
          })}
        </div>
      ) : (
        <Nothing style={{ height: '640px' }} title='Ничего не найдено' />
      )}
    </div>
  );
};
